export default "__VITE_ASSET__Bdd9Yu8F__"